import { Button, Form, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { ReactElement, useCallback, useState } from 'react';
import Layout from '~Reports/Layout';
import DatePicker from '~UI/DatePicker';

interface IErrors {
    dateRange?: string;
}

export default function InvestmentsTransactions(): ReactElement {
    const [ endDate, setEndDate ] = useState<string>(null);
    const [ errors, setErrors ] = useState<IErrors>({});
    const [ startDate, setStartDate ] = useState<string>(null);

    const validateDateRange: () => boolean = useCallback(() => {
        let error: string;

        if (!startDate || !endDate) {
            error = 'Please enter a date range';
        }

        if (dayjs(endDate).diff(startDate, 'day') > 31) {
            error = 'Please enter dates that span a month at most';
        }

        setErrors((prevErrors: IErrors) => ({
            ...prevErrors,
            dateRange: error,
        }));

        return !error;
    }, [
        endDate,
        startDate,
    ]);

    const onChangeDateRange: (dateRange: [Dayjs, Dayjs]) => void = useCallback((dateRange: [Dayjs, Dayjs]) => {
        setEndDate(dateRange[1].format('YYYY-MM-DD')),
        setStartDate(dateRange[0].format('YYYY-MM-DD'));
    }, []);

    const onClickDownload: () => void = useCallback(() => {
        let valid: boolean = true;

        valid = validateDateRange() && valid;

        if (!valid) {
            return;
        }

        window.open(`${process.env.API_HOST}/investment-reports/transactions?startDate=${startDate}&endDate=${endDate}`, '_blank');
    }, [
        endDate,
        startDate,
        validateDateRange,
    ]);

    return (
        <Layout section='investments-transactions'>
            <Typography.Title level={2}>Investments - Transactions</Typography.Title>
            <Form.Item
                className='date-range'
                help={errors.dateRange}
                label='Date Range'
                validateStatus={errors.dateRange && 'error'}
            >
                <DatePicker.RangePicker
                    picker='date'
                    format='DD/MM/YYYY'
                    onBlur={validateDateRange}
                    onChange={onChangeDateRange}
                    value={[ startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null ]}
                />
            </Form.Item>
            <Form.Item>
                <Button onClick={onClickDownload} type='primary'>Download</Button>
            </Form.Item>
        </Layout>
    );
}
